var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHwDispenser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.3 48",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "Hot Water Dispenser") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m39.8 21.7c0-0.4-0.3-0.8-0.7-0.8s-0.7 0.3-0.7 0.8v2.4c0 0.4 0.3 0.8 0.7 0.8s0.7-0.3 0.7-0.8v-2.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m38.4 28.3v2.4c0 0.4 0.3 0.8 0.7 0.8s0.7-0.3 0.7-0.8v-2.4c0-0.2-0.1-0.4-0.2-0.5s-0.3-0.2-0.5-0.2c-0.4-0.1-0.7 0.3-0.7 0.7z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m36.2 21.7c0-0.4-0.3-0.8-0.7-0.8s-0.7 0.3-0.7 0.8v2.4c0 0.4 0.3 0.8 0.7 0.8s0.7-0.3 0.7-0.8v-2.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m34.8 28.3v2.4c0 0.4 0.3 0.8 0.7 0.8s0.7-0.3 0.7-0.8v-2.4c0-0.2-0.1-0.4-0.2-0.5s-0.3-0.2-0.5-0.2c-0.4-0.1-0.7 0.3-0.7 0.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m43.3 46.1h-23.4v-3.8c0-0.6-0.4-1-1-1h-1.5v-26.2c0-4.4 3.6-8 8-8s8 3.6 8 8v3c0 0.6 0.4 1 1 1h5c0.6 0 1-0.5 1-1v-3c0-8.3-6.7-15.1-15.1-15.1-8.3 0-15.1 6.8-15.1 15.1v17.1h-1v-0.5c0-0.7-0.6-1.3-1.3-1.3s-1.3 0.6-1.3 1.3v3.2c0 0.7 0.6 1.3 1.3 1.3s1.3-0.6 1.3-1.3v-0.7h1v7.1h-1.5c-0.6 0-1 0.5-1 1v3.8h-6.6c-0.5 0-0.9 0.4-0.9 0.9s0.4 0.9 0.9 0.9h42.2c0.5 0 0.9-0.4 0.9-0.9s-0.4-0.9-0.9-0.9zm-35-11.2c0 0.1-0.1 0.2-0.2 0.2s-0.2-0.1-0.2-0.2v-3.2c0-0.1 0.1-0.2 0.2-0.2s0.2 0.1 0.2 0.2v3.2zm30.1-17.8h-3v-2h3v2zm-26.1-2c0-7.2 5.8-13.1 13.1-13.1 6.6 0 12 4.9 12.9 11.2h-3c-0.9-4.7-5-8.2-9.9-8.2-5.5 0-10 4.5-10 10.1v26.1h-3v-26.1zm5.9 30.8h-8.8v-2.6h8.8v2.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHwDispenser);
export default __webpack_public_path__ + "static/media/hw-dispenser.811cebe4bbf4f43db8bcc98d9cf3a19e.svg";
export { ForwardRef as ReactComponent };